// extracted by mini-css-extract-plugin
export default {"legend":"Nna-z","legendSpacing":"Ona-z"};